import {
  flow,
  sortBy,
  groupBy,
  get,
  omit,
  flatten,
  uniq,
  map,
  filter,
} from 'lodash';

import * as constants from 'modules/AccountabilitySystemAnalytics/K12Admin/store/constants';

const initialState = {
  context: {
    planScopes: [],
    yearsToShow: [],
    categories: [],
    responsibleParties: [],
  },
  loadingIndicators: false,
  activePlanScope: undefined,
  selectedIndicator: undefined,
  selectedIndicatorType: undefined,
  planScopesById: {},
  indicatorsList: undefined,
  indicatorAnalyticsSearchState: {},
  indicatorsBreakoutById: {},
  detailsDrawerOpen: false,
  schoolYear: undefined,
  indicatorAnalyticsSearchCount: 0,
};

// eslint-disable-next-line complexity
export default (state = initialState, action) => {
  switch (action.type) {
    case constants.POPULATE_CONTEXT:
      return {
        ...state,
        context: action.context,
        schoolYear: !state.schoolYear
          ? action.context.currentYear
          : state.schoolYear,
      };
    case constants.POPULATE_PLAN_SCOPE_DETAILS:
      return {
        ...state,
        planScopesById: {
          ...state.planScopesById,
          [action.planScope]: {
            ...state.planScopesById[action.planScope],
            ...action.data,
            gradesWithIndicators: flow([
              values => map(values, i => i.indicators),
              values => flatten(values),
              values => map(values, i => +i.gradeYear),
              values => uniq(values),
              values => values.sort((a, b) => a - b),
            ])(action.data),
            categories: flow([
              values => filter(values, i => i.indicators.length),
              values => sortBy(values, 'category.order'),
              values => groupBy(values, 'category.name'),
              values =>
                map(values, (value, key) => {
                  const mappedIndicatorTypes = value.map(indicatorType => ({
                    ...indicatorType,
                    grades: indicatorType.indicators.map(indicator => ({
                      grade: indicator.gradeYear,
                      isPlanned: true,
                      plannedAt: indicator.plannedAt,
                      isConfigured: !!indicator.configuredAt,
                      configuredAt: indicator.configuredAt,
                      isActivated: !!indicator.activatedAt,
                      activatedAt: indicator.activatedAt,
                      indicator,
                      districtIndicator: indicator.districtIndicator,
                      studentIndicators: indicator.studentIndicators,
                    })),
                  }));
                  return {
                    category: key,
                    indicatorTypes: sortBy(mappedIndicatorTypes, 'order'),
                  };
                }),
            ])(action.data),
          },
        },
      };
    case constants.POPULATE_INDICATORS:
      return {
        ...state,
        indicatorsList: action.data,
      };
    case constants.POPULATE_INDICATOR_COUNT:
      return {
        ...state,
        indicatorAnalyticsSearchCount: action.data,
      };
    case constants.POPULATE_INDICATOR_BREAKOUT_DETAILS:
      return {
        ...state,
        indicatorsBreakoutById: {
          ...state.indicatorsBreakoutById,
          [action.indicatorUuid]: {
            breakoutVariable: action.data.breakoutVariable,
            trueCount: action.data.trueCount,
            falseCount: action.data.falseCount,
            pointsAchievedCount: action.data.pointsAchievedCount,
            pointsNotAchievedCount: action.data.pointsNotAchievedCount,
            unreportedCount: action.data.unreportedCount,
            overallTrueStudentsHash: action.data.overallTrueStudentsHash,
            overallFalseStudentsHash: action.data.overallFalseStudentsHash,
            overallUnreportedStudentsHash:
              action.data.overallUnreportedStudentsHash,
            breakoutOptions: action.data.breakoutOptions,
            breakoutCsvOptions: action.data.breakoutCsvOptions,
            hasHistoricalData: action.data.hasHistoricalData,
            breakoutData: {
              ...get(
                state,
                `indicatorsBreakoutById.${action.indicatorUuid}.breakoutData`,
                {},
              ),
              [action.data.breakoutVariable]: action.data.breakoutData,
            },
          },
        },
      };
    case constants.CLEAR_INDICATOR_BREAKOUT_DETAILS:
      return {
        ...state,
        indicatorsBreakoutById: {},
        selectedIndicator: undefined,
      };
    case constants.SET_PLAN_SCOPE:
      return {
        ...state,
        activePlanScope: action.planScope,
      };
    case constants.SET_INDICATOR:
      return {
        ...state,
        selectedIndicator: action.indicator,
      };
    case constants.SET_INDICATOR_TYPE:
      return {
        ...state,
        selectedIndicatorType: action.indicatorType,
      };
    case constants.OPEN_DETAILS_DRAWER:
      return {
        ...state,
        detailsDrawerOpen: true,
      };
    case constants.CLOSE_DETAILS_DRAWER:
      return {
        ...state,
        detailsDrawerOpen: false,
      };
    case constants.SET_SCHOOL_YEAR:
      return {
        ...state,
        schoolYear: action.schoolYear,
      };
    case constants.SET_LOADING_INDICATORS:
      return {
        ...state,
        loadingIndicators: action.mode,
      };
    case constants.SET_INCOMING_SEARCH_TERM:
      return {
        ...state,
      };
    case constants.APPEND_INDICATORS:
      return {
        ...state,
        indicatorsList: [...state.indicatorsList, ...action.data],
      };
    case constants.POPULATE_INDICATORS_ANALYTICS_SEARCH_STATE:
      return {
        ...state,
        indicatorAnalyticsSearchState: omit(action.data, ['results']),
      };
    case constants.CLEAR_INDICATORS_ANALYTICS_SEARCH_STATE:
      return {
        ...state,
        indicatorAnalyticsSearchState: {},
        indicatorsList: undefined,
      };
    case constants.UPDATE_GRID_STUDENT_COUNTS:
      return {
        ...state,
        planScopesById: {
          ...state.planScopesById,
          [action.planScope]: {
            ...state.planScopesById[action.planScope],
            indicatorCounts: action.data.reduce(
              (result, item) => ({
                ...result,
                [item.uuid]: item,
              }),
              {},
            ),
          },
        },
      };
    case constants.SET_ACTIVE_ELEMENT:
      return {
        ...state,
        activeElement: action.activeElement,
      };
    default:
      return state;
  }
};
